module.exports = __webpack_public_path__ + "static/media/facebook.f7659a97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.svg
// module id = 637
// module chunks = 0